import JSON5      from 'json5';
import configFile from '../../config/main.json5?raw';

class Config {
	static isInitialized = false;
	// основные настройки конфига
	static app;
	static environment;
	static serverName;
	static debug;
	static localCountry;
	static localCurrency;
	static localDefaultVatRate
	static sibWellPartnerId;
	static api;
	static sentry;
	static dialogs;
	static toast;
	static connectionMonitor;

	static async init() {
		if (this.isInitialized) {
			return this;
		}
		this.loadConfig();
		this.validate();
		this.isInitialized = true;
		//console.debug('📋 Config инициализирован');
	}

	static get isDev() {
		return this.environment === 'dev';
	}

	static loadConfig() {
		try {
			// Парсим JSON5 конфигурацию
			const configData = JSON5.parse(configFile);
			for (const field of Object.keys(configData)) {
				Config[field] = configData[field];
			}
			console.debug(`Конфигурация загружена для окружения: ${this.environment}`);
		} catch (error) {
			console.error('Ошибка загрузки конфигурации:', error);
			throw new Error('Не удалось загрузить конфигурацию приложения');
		}
	}

	// Валидация обязательных настроек
	static validate() {
		const required = [
			'app',
			'environment',
			'serverName',
			'debug',
			'localCountry',
			'localCurrency',
			'sibWellPartnerId',
			'api',
			'sentry',
		];
		const missing = required.filter(field => {
			const value = this[field];
			return value === undefined || value === null || value === '';
		});
		if (missing.length > 0) {
			throw new Error(`Config: отсутствуют обязательные настройки: ${missing.join(', ')}`);
		}
	}
}

export default Config;
